import { REPORTS_DATA_SUCCESS } from './actionTypes';

export const reportsReducer = (state, action) => {

    if(action.type === REPORTS_DATA_SUCCESS) {      
        return {
            ...state,
            reportDetails : action.payload.reportDetails           
        }   
    }             
    else {
         return state;   
    }
}

